// extracted by mini-css-extract-plugin
export var optionGrid = "_5g-7";
export var optionList = "_5g-6";
export var questionsBlock = "_5g-9";
export var spacer = "_5g-5";
export var stepCenteredContent = "_5g-3";
export var stepInner = "_5g-0";
export var stepInnerFullWidth = "_5g-1";
export var stepInnerLockScroll = "_5g-2";
export var stepTransitionFrame = "_5g-4";
export var welcomeBlock = "_5g-8";